
import { Database } from '../hooks/useDatabasesData';

export const mockDatabases: Database[] = [
  {
    id: '1',
    name: 'Production Database',
    type: 'postgresql',
    host: 'db.example.com',
    port: '5432',
    username: 'admin',
    password: '********',
    database: 'production',
    status: 'connected'
  },
  {
    id: '2',
    name: 'Analytics Database',
    type: 'mysql',
    host: 'analytics.example.com',
    port: '3306',
    username: 'analyst',
    password: '********',
    database: 'analytics',
    status: 'connected'
  },
  {
    id: '3',
    name: 'Legacy System',
    type: 'mssql',
    host: 'legacy.internal',
    port: '1433',
    username: 'readonly',
    password: '********',
    database: 'legacy_data',
    status: 'disconnected'
  }
];
